export default __webpack_public_path__ + "static/media/milkBunSmall.d82b180a.svg";